import { Navigate, Route, Routes } from "react-router-dom";
import Auth from "../layout/auth";
import Login from "../pages/auth/login";
import Register from "../pages/auth/register";
import ForgotPassword from "../pages/auth/forgot-password";
import Dashboard from "../pages/dashboard/index";
import Announcement from "../pages/announcement/index";
import Universities from "../pages/universities/index";
import UniversityDetail from "../pages/universities/detail";
import EditUniversityDetail from "../pages/universities/edit-detail";
import UniversityFormPage from "../pages/universities/university-form";
import ProgramFormPage from "../pages/programs/program-form";
import Programs from "../pages/programs/index";
import Students from "../pages/students/index";
import StudentEditPage from "../pages/students/edit";
import StudentCreatePage from "../pages/students/create";
import Applications from "../pages/applications/index";
import Agents from "../pages/agents/index";
import AgentFormPage from "../pages/agents/agent-form";
import AgentCommissions from "../pages/agents/commissions/index";
import AgentCommissionDetail from "../pages/agents/commissions/detail";
import Profile from "../pages/profile/index";
import RouterHelper from "./route-helper";
import UniMap from "../pages/unimap/index";
import PreferenceDatesPage from "../pages/preference-dates";
import RegistrationDatesPage from "../pages/registration-dates";
import ExamDatesPage from "../pages/exam-dates";

const AppRouter = () => {
    return (
        <Routes>
            <Route path="/" element={<Navigate to="/dashboard" replace />} />

            {/* Protected routes - RouterHelper ile korumalı */}
            <Route path="/dashboard" element={<RouterHelper component={<Dashboard />} />} />
            <Route path="/announcement" element={<RouterHelper component={<Announcement />} />} />
            <Route path="/universities" element={<RouterHelper component={<Universities />} />} />
            <Route path="/universities/new" element={<RouterHelper component={<UniversityFormPage />} />} />
            <Route path="/universities/:id" element={<RouterHelper component={<UniversityDetail />} />} />
            <Route path="/universities/:id/edit" element={<RouterHelper component={<UniversityFormPage />} />} />
            <Route path="/universities/:id/edit-detail" element={<RouterHelper component={<EditUniversityDetail />} />} />
            <Route path="/programs" element={<RouterHelper component={<Programs />} />} />
            <Route path="/programs/new" element={<RouterHelper component={<ProgramFormPage />} />} />
            <Route path="/programs/new" element={<RouterHelper component={<ProgramFormPage />} />} />
            <Route path="/programs/:id/edit" element={<RouterHelper component={<ProgramFormPage />} />} />
            <Route path="/students" element={<RouterHelper component={<Students />} />} />
            <Route path="/students/new" element={<RouterHelper component={<StudentCreatePage />} />} />
            <Route path="/students/:id/edit" element={<RouterHelper component={<StudentEditPage />} />} />
            <Route path="/applications" element={<RouterHelper component={<Applications />} />} />
            <Route path="/agents" element={<RouterHelper component={<Agents />} />} />
            <Route path="/agents/new" element={<RouterHelper component={<AgentFormPage />} />} />
            <Route path="/agents/:id/edit" element={<RouterHelper component={<AgentFormPage />} />} />
            <Route path="/agent-commissions" element={<RouterHelper component={<AgentCommissions />} />} />
            <Route path="/agent-commissions/:id" element={<RouterHelper component={<AgentCommissionDetail />} />} />
            <Route path="/profile" element={<RouterHelper component={<Profile />} />} />
            <Route path="/unimap" element={<RouterHelper component={<UniMap />} />} />
            <Route path="/registration-dates" element={<RouterHelper component={<RegistrationDatesPage />} />} />
            <Route path="/preference-dates" element={<RouterHelper component={<PreferenceDatesPage />} />} />
            <Route path="/exam-dates" element={<RouterHelper component={<ExamDatesPage />} />} />

            {/* Public routes - withoutAccess ile korumasız */}
            <Route path="/auth/login" element={<RouterHelper component={<Auth><Login /></Auth>} withoutAccess={true} />} />
            <Route path="/auth/register" element={<RouterHelper component={<Auth><Register /></Auth>} withoutAccess={true} />} />
            <Route path="/auth/forgot-password" element={<RouterHelper component={<Auth><ForgotPassword /></Auth>} withoutAccess={true} />} />
        </Routes>
    )
}
export default AppRouter;